export default "__VITE_ASSET__DaiOiBVA__"